import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  const links = [
    { label: "Membership", id: "membership" },
    { label: "Chi sono", id: "chi-sono" },
    { label: "Testimonianze", id: "testimonianze" },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? "navbar-glass shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => scrollTo("hero")}
            className="flex items-center gap-2"
            data-testid="navbar-logo"
          >
            <span className="font-heading text-xl font-semibold tracking-tight text-[#442F23] leading-tight">
              <span className="gold-shimmer text-lg">Stella Soul Coach</span>
              <br />
              <span className="text-sm font-body font-normal text-[#AC8E60] tracking-wider uppercase">Light Workers House</span>
            </span>
          </button>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-10">
            {links.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="text-sm font-medium tracking-wide text-[#442F23]/70 hover:text-[#AC8E60] transition-colors duration-300 uppercase"
                data-testid={`nav-${link.id}`}
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("pricing-section")}
              className="btn-primary text-sm px-6 py-2.5"
              data-testid="nav-cta"
            >
              Unisciti
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 text-[#442F23]"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden navbar-glass border-t border-[#AC8E60]/10"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {links.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-left text-base font-medium text-[#442F23]/80 hover:text-[#AC8E60] transition-colors py-2"
                  data-testid={`mobile-nav-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
              <button
                onClick={() => scrollTo("pricing-section")}
                className="btn-primary text-sm mt-2 text-center"
              >
                Unisciti
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
